import BossModel from "@/models/BossModel";

export default class MarketingChannel extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'customer/marketing-channel';

    /**
     *
     * @type {string}
     */
    static entity = 'marketingchannels';

    static fields() {
		return {
			id: this.number(null).nullable(),
			code: this.attr(null),
			name: this.attr(null),
			is_active: this.boolean(null),
		}
	}

    /**
     * @param params
     * @returns {*}
     */
    static fetchAllForSelect(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .get(true);
    }
}
